import { useEffect, useState } from "react";
import NotesTableUI from "../components/NotesTableUI";
import socket from "../../socket";
import { getUser } from "../../auth"

const URL = process.env.REACT_APP_API_URL;


export default function NotesTable({ user_rol }) {
  const [notes, setNotes] = useState([]);
  
  const fetchNotes = () => {
    const user = getUser();
    fetch(`${URL}/api/notes/`,{
      headers: {
        "X-Empresa-Id": user?.empresa_id
      }
    })
      .then((res) => {
        if (!res.ok) throw new Error('Error al obtener notas');
        return res.json();
      })
      .then((data) => setNotes(data))
      .catch((error) => console.error(error));
  } 

  useEffect(() => {
    fetchNotes();
    socket.on("nota_creada", fetchNotes);
    socket.on("nota_borrada", fetchNotes);
    
    return () => {
      socket.off("nota_creada", fetchNotes);
      socket.off("nota_borrada", fetchNotes);
    };
  }, []);

  return(
    <NotesTableUI notes={notes} rol={user_rol} />
  )
}